import Joyride from 'react-joyride';
import { useTour } from '../../shared/TourContext';
import { useLocation } from 'react-router-dom';
import { TourTooltip } from './TourTooltip';

export default function TourRunner() {
  const { runTour, setRunTour, steps } = useTour();
  const location = useLocation();

  return (
      <Joyride
        key={`joyride-${location.pathname}`}
        steps={steps}
        run={runTour}
        continuous
        tooltipComponent={TourTooltip}
        callback={(data) => {
          const { status, action } = data;
          if (["skipped", "finished", "close"].includes(status) || action === 'close') {
            setRunTour(false);
          }
        }}
        styles={{
          options: {
            overlayColor: 'rgba(0,0,0,0.6)',
          },
        }}
    />
  );
}
